import RegistrationHandler from './RegistrationHandler';

export default RegistrationHandler;
